/**
 * composables/useDatabase.ts
 *
 * Composable for accessing the current user's database
 */

import { useDatabaseStore } from '@/stores/database'
import type { FolderFeedDB } from '@/stores/database'

/**
 * Get the current user's database instance
 *
 * @returns The current database instance
 * @throws Error if database is not initialized (user not logged in)
 */
export function useDatabase (): FolderFeedDB {
    const databaseStore = useDatabaseStore()
    return databaseStore.getDatabase()
}
